module.exports = __webpack_public_path__ + "static/media/sovellustunnus_unitspotter_logo_rgb.3cf3fce5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/unitspotterMediaLogos/sovellustunnus_unitspotter_logo_rgb.pdf
// module id = 1446
// module chunks = 0